<template>
    <div class="col-sm-4">Buildings/Designs</div>
    <div class="col-sm-8">

        <div class="row">
            <div class="col modspec_titleTable">Building:</div>
            <div class="col modspec_titleTable">Class:</div>
            <div class="col modspec_titleTable">Size:</div>
            <div v-if="isJVorDTS" class="col modspec_titleTable">Orientations:</div>
            <div class="col modspec_titleTable"></div>
        </div>
        <div class="row modspec_font12" v-for="(building, ibuild) in buildings" :key="building.Name">
            <div class="col">{{ building.Name }}</div>
            <div class="col">{{ getClassName(building.BuildingClass) }}</div>
            <div class="col">{{ building.Area == '' ? building.NumModules + ' mod' : building.Area + 'm2' }}</div>
            <div v-if="isJVorDTS" class="col">{{ building.NumOrientations }}</div>
            <div class="col">
                <a href="#" @click="deleteBuilding(ibuild, $event)"><i class="bi bi-eraser"></i></a>
            </div>
        </div>

    </div>

    <div class="col-sm-4"><button v-if="verAdd" type="button" class="btn btn-primary" data-bs-toggle="modal"
            data-bs-target="#mdlAddBuilding"><i class="bi bi-plus"></i> Add</button></div>

    <!--------------------------------------------------------------------------------------------->
    <div class="modal fade" id="mdlAddBuilding" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title modspec_title-small">Add buildings</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <label class="col-sm-4">Building:</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" v-model="newBuilding.Name"
                                placeholder="type here ..." />
                        </div>
                    </div>

                    <div v-if="canSeePreviousBuildings && !isDTS">
                        <div class="row mt-2">
                            <label class="col-sm-4"></label>
                            <div class="col-sm-8">
                                <input class="form-check-input" type="checkbox" name="chkSeeEnergyPreviousJobs"
                                    id="chkSeeEnergyPreviousJobs" value="0" v-model="seeEnergyPreviousJob" />
                                <label class="form-check-label modspec_font12" for="chkSeeEnergyPreviousJobs"
                                    @click="changeSeeEnergyPreviousJob">
                                    Use energy model from previous job </label>
                            </div>
                        </div>
                        
                        <div v-if="seeEnergyPreviousJob">
                            <div class="row mt-2" v-if="thereIsPreviousJobs">
                                <label class="col-sm-4">Select:</label>
                                <div v-if="loadBuildings" class="col-sm-8">
                                    <select class="form-select" v-model="newBuilding.IdBuildingEnergy">
                                        <option value=""></option>
                                        <option v-for="mb in myBuildingsList.energy" :key="mb.idBuilding" :value="mb.idBuilding">
                                            {{ mb.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div v-else class="row mt-2">
                                <label class="col-sm-4"></label>
                                <div class="col-sm-8">
                                    <label class="form-check-label modspec_font12">Data not yet provided for client library </label>
                                </div>
                            </div>
                        </div>
                        
                    </div>

                    <div class="row mt-2">
                        <label class="col-sm-4">Class:</label>
                        <div class="col-sm-8">
                            <select class="form-select" v-model="newBuilding.BuildingClass">
                                <option value=""></option>
                                <option v-for="(cnt) in constructionsFilter" :key="cnt.value" :value="cnt.value">
                                    {{ cnt.label }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-2" v-if="isJVorDTS">
                        <orientation ref="borientation" @setOrientation="setOrientation($event)"
                            :origin="'buildings'" />
                    </div>
                    <div class="row mt-2">
                        <label class="col-sm-4">Building Size</label>
                        <div class="col-sm-4">
                            <select class="form-select" v-model="newBuilding.NumOrArea" @change="numModules">
                                <option value="number">number of modules</option>
                                <option value="area">use area</option>
                            </select>
                        </div>
                        <div class="col-sm-1 text-center"><span v-if="selectArea">or</span></div>
                        <div class="col-sm-3" v-if="selectNumModules">
                            <input ref="myarea" type="number" class="form-control" v-model="newBuilding.NumModules"
                                placeholder="#" />
                        </div>
                        <div class="col-sm-3" v-if="selectArea">
                            <input ref="myarea" type="number" class="form-control" v-model="newBuilding.Area"
                                placeholder="area m2" />
                        </div>
                    </div>

                    <div v-if="canSeePreviousBuildings">
                        <div class="row mt-2">
                            <label class="col-sm-4"></label>
                            <div class="col-sm-8">
                                <input class="form-check-input" type="checkbox" name="chkSeeConstructionPreviousJob"
                                    id="chkSeeConstructionPreviousJob" value="0" v-model="seeConstructionPreviousJob" />
                                <label class="form-check-label modspec_font12" for="chkSeeConstructionPreviousJob"
                                    @click="changeSeeConstructionPreviousJob">
                                    Use construction details from previous job </label>
                            </div>
                        </div>
                        
                        <div v-if="seeConstructionPreviousJob">
                            <div class="row mt-2" v-if="thereIsPreviousJobs">
                                <label class="col-sm-4">Select:</label>
                                <div v-if="loadBuildings" class="col-sm-8">
                                    <select class="form-select" v-model="newBuilding.IdBuildingDetail">
                                        <option value=""></option>
                                        <option v-for="mb in myBuildingsList.construction" :key="mb.idBuilding" :value="mb.idBuilding">
                                            {{ mb.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mt-2" v-else>
                                <label class="col-sm-4"></label>
                                <div class="col-sm-8">
                                    <label class="form-check-label modspec_font12">Data not yet provided for client library </label>
                                </div>
                            </div>
                        </div>
                        
                    </div>


                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" id="btnClosemdlAddBuilding" data-bs-dismiss="modal"
                        @click="closeAddBuilding">Close</button>
                    <button type="button" class="btn btn-primary" @click="addNewBuilding">Add</button>
                </div>
            </div>
        </div>
    </div>
    <!------------------------------------------------------------------------------------------------>
</template>
<script>
import data from "../../helpers/data.json";
import orientation from "./nq-orientation.vue";

export default {
    name: "pagina-building",
    props: ['method','idCliente', 'isAdmin'],
    components: {
        orientation: orientation,
    },
    data: function () {
        return {
            newBuilding: {
                Name: '',
                BuildingClass: '',
                NumOrArea:'',
                NumModules: '',
                Area: '',
                NumOrientations: 0,
                Orientations: '',
                IdBuildingEnergy: null,
                IdBuildingDetail: null
            },
            buildings: [],
            construction: data.construction,
            myBuildings: [],
            myBuildingsList:{energy:[],construction:[]},
            loadBuildings: false,
            seeEnergyPreviousJob: false,
            seeConstructionPreviousJob: false,
            idClient:0
        }
    },
    mounted() {
        this.loadMiBuildings();
    },
    methods: {
        loadMiBuildings() {
            let self = this;
            this.$vtc.vtcFetch("/Client/GetMyBuildings?idC=" + this.idCliente, null,'API2').then(
                function (data) {
                    self.myBuildings = data;
                    self.loadBuildings = true;
                    //Include > JV3 & J1V3 previous projects, and buildings from Handbooks
                    self.myBuildingsList.energy = data.filter(b => {
                        return (b.idServiceType == 1 || b.idServiceType == 2 || b.idServiceType == 5 || b.idServiceType == 6) && b.idOrigin == 1;
                    });
                    //Include > JV3 & J1V3 previous projects
                    self.myBuildingsList.construction = data.filter(b => {
                        return b.idServiceType == 1 || b.idServiceType == 2;
                    });
                }
            );
        },
        reset() {
            this.buildings = [];
            this.seeEnergyPreviousJob = false;
            this.seeConstructionPreviousJob = false;
            this.$emit('setBuildings', this.buildings);
        },
        setBuildingsValue(buildings) {
            this.buildings = (buildings || []).map((building) => {
                const area = building.Area || building.area || '';
                const modules = building.NumModules || building.numModules || '';
                return {
                    Name: building.Name || building.name || '',
                    BuildingClass: building.BuildingClass || building.buildingClass || '',
                    NumOrArea: area && parseFloat(area) > 0 ? 'area' : 'number',
                    NumModules: modules || 0,
                    Area: area || 0,
                    NumOrientations: building.NumOrientations || building.numOrientations || 0,
                    Orientations: building.Orientations || building.orientations || '',
                    IdBuildingEnergy: building.IdBuildingEnergy || building.idBuildingEnergy || null,
                    IdBuildingDetail: building.IdBuildingDetail || building.idBuildingDetail || null
                };
            });
            this.$emit('setBuildings', this.buildings);
        },
        addNewBuilding() {
            //validating
            if (this.newBuilding.Name == '') {
                alert("Insert a building");
                return false;
            }
            if (this.newBuilding.BuildingClass == '') {
                alert("Select a class");
                return false;
            }
            if (this.newBuilding.NumOrArea == '') {
                alert("Select number of modules or area");
                return false;
            }
            if (this.newBuilding.NumOrArea == 'number' && (this.newBuilding.NumModules == '' || this.newBuilding.NumModules == 0)) {
                alert("Input a number of module");
                return false;
            }
            if (this.isJVorDTS && this.newBuilding.NumOrientations == 0) {
                alert("Select a orientation");
                return false;
            }
            if (this.newBuilding.NumOrArea == 'area' && this.newBuilding.Area == '') {
                alert("Insert an area");
                return false;
            }

            if (this.newBuilding.NumOrArea == 'number') {
                this.newBuilding.Area = 0;
            }
            else if (this.newBuilding.NumOrArea == 'area') {
                this.newBuilding.NumModules = 0;
            }

            if (this.newBuilding.BuildingClass !== '') this.newBuilding.BuildingClass = parseInt(this.newBuilding.BuildingClass);

            if (this.newBuilding.IdBuildingEnergy == '') this.newBuilding.IdBuildingEnergy = null;
            if (this.newBuilding.IdBuildingDetail == '') this.newBuilding.IdBuildingDetail = null;

            //if admin is creating the quote, he can give discount without buildings
            if(this.isAdmin){
                if(this.seeEnergyPreviousJob) this.newBuilding.IdBuildingEnergy = -1
                if(this.seeConstructionPreviousJob) this.newBuilding.IdBuildingDetail = -1            
            }    


            //verify
            this.buildings.push(this.newBuilding);

            this.newBuilding = {
                Name: '',
                BuildingClass: '',
                NumOrArea:'',
                NumModules: '',
                Area: '',
                NumOrientations: 0,
                Orientations: '',
                IdBuildingEnergy: null,
                IdBuildingDetail: null
            };

            this.seeEnergyPreviousJob = false;
            this.seeConstructionPreviousJob = false;

            if (this.isJVorDTS) this.$refs.borientation.reset();
            this.$emit('setBuildings', this.buildings);
            document.getElementById('btnClosemdlAddBuilding').click();
        },
        numModules() {
            if (this.newBuilding.NumOrArea == 'area') {
                if (this.$refs.myarea != undefined) this.$refs.myarea.focus()
            }
        },
        deleteBuilding(index, e) {
            e.preventDefault();
            this.buildings.splice(index, 1);
            this.$emit('setBuildings', this.buildings);
        },
        getClassName(classId) {
            return data.construction.find(c => c.value == classId)?.short_name || ''
        },
        setOrientation(ev) {
            this.newBuilding.NumOrientations = ev.number;
            this.newBuilding.Orientations = ev.orientations;
        },
        changeSeeEnergyPreviousJob() {
            this.newBuilding.IdBuildingEnergy = null;
        },
        changeSeeConstructionPreviousJob() {
            this.newBuilding.IdBuildingDetail = null;
        },
        closeAddBuilding() {

            this.seeEnergyPreviousJob = false;
            this.seeConstructionPreviousJob = false;
        }
    },
    computed: {
        constructionsFilter() {
            if (this.$vtc.isV2(this.method)) {
                return data.construction.filter(c => c.id_service_type == this.method);
            }
            return data.construction.filter(c => c.id_service_type == 0);
        },
        isDTS() {
            return this.$vtc.isDTS(this.method);
        },
        isJVorDTS() {
            return this.$vtc.isJVorDTS(this.method);
        },
        isV2() {
            return this.$vtc.isV2(this.method);
        },
        verAdd() {
            /*if (this.$vtc.isJVorDTS(this.method) && this.buildings.length > 0) {
                return false;
            }*/
            return true;
        },
        selectArea() {
            return this.newBuilding.NumOrArea == 'area';
        },
        selectNumModules(){
            return this.newBuilding.NumOrArea == 'number';
        },
        canSeePreviousBuildings() {
            return this.isJVorDTS;// && this.myBuildings.length != 0;
        },
        thereIsPreviousJobs(){
            return this.myBuildingsList.construction.length > 0 && this.myBuildingsList.energy.length > 0
            //return this.myBuildings.length > 0;
        }
    }
}
</script>
<style scoped>
.form-select {
    font-size: 12px !important;
}

.form-control {
    font-size: 12px !important;
}
</style>
